//src/services/reports.ts
import { api, type DownloadResponse } from "@/lib/apiClient";
import type {
  CampaignAnalyticsReport,
  PsychosocialEvolutionReport,
  ReportsOptions,
  RiskInventoryActionPlansReport,
} from "@/types/reports";

export type CommonReportFilters = {
  unit_id?: string;
  department_id?: string;
  job_position_id?: string;
  worker_group_id?: string;
  dimension_id?: string;
  risk_id?: string;
};

export type PsychosocialEvolutionFilters = CommonReportFilters & {
  inventory_id: string;
  campaign_ids?: string[];
  period_start?: string;
  period_end?: string;
};

export type CampaignAnalyticsFilters = Omit<CommonReportFilters, "risk_id"> & {
  campaign_id: string;
  include_questions?: boolean;
  include_distribution?: boolean;
};

export type RiskInventoryActionPlansFilters = CommonReportFilters & {
  inventory_id: string;
  campaign_id?: string;
  risk_classification?: string;
  item_status?: string;
  action_status?: string;
  responsible_user_id?: string;
  deadline_start?: string;
  deadline_end?: string;
};

export async function getReportsOptions() {
  return api.get<ReportsOptions>("/reports/options");
}

export async function getPsychosocialEvolutionReport(params: PsychosocialEvolutionFilters) {
  return api.get<PsychosocialEvolutionReport>("/reports/psychosocial-evolution", {
    params,
  });
}

export async function getCampaignAnalyticsReport(params: CampaignAnalyticsFilters) {
  return api.get<CampaignAnalyticsReport>("/reports/campaign-analytics", {
    params,
  });
}

export async function getRiskInventoryActionPlansReport(params: RiskInventoryActionPlansFilters) {
  return api.get<RiskInventoryActionPlansReport>("/reports/risk-inventory-action-plans", {
    params,
  });
}

export async function downloadRiskInventoryExcelReport(params: RiskInventoryActionPlansFilters) {
  return api.download("/reports/risk-inventory/export", {
    params,
  }) as Promise<DownloadResponse>;
}
